<h2 class="m-0 text-uppercase">{{ 'fe_hbspt_form_h2_title' | translate }}</h2>
<h3 class="m-0 py-1">
    {{ 'fe_hbspt_form_title_1' | translate }}
    {{ 'fe_hbspt_form_title_2' | translate }}
</h3>
<p class="m-0 mb-3">{{ 'fe_hbspt_form_subtitle' | translate }}</p>
<div id="hubspotForm"></div>
